export const PRODUCT_LINKS = [
    { idx: "P.01", slug: "gate-openers", title: { en: "Gate Openers", hi: "गेट ओपनर" } },
    { idx: "P.02", slug: "door-openers", title: { en: "Door Openers", hi: "डोर ओपनर" } },
    { idx: "P.03", slug: "pedestrian-openers", title: { en: "Pedestrian Openers", hi: "पैदल ओपनर" } },
    { idx: "P.04", slug: "parking-barriers", title: { en: "Parking Barriers", hi: "पार्किंग बैरियर" } },
    { idx: "P.05", slug: "access-control", title: { en: "Access Control Devices", hi: "एक्सेस कंट्रोल डिवाइस" } },
    { idx: "P.06", slug: "card-biometric-readers", title: { en: "Card & Biometric Readers", hi: "कार्ड व बायोमेट्रिक रीडर" } },
    { idx: "P.07", slug: "software-solutions", title: { en: "Software Solutions", hi: "सॉफ्टवेयर सॉल्यूशन" } },
];